import { render } from "./PortalPrivateLearningCoachingDefaultView.vue?vue&type=template&id=71bbe30e"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__